import React from "react";
import { HandbookArticlePage } from "./HandbookArticlePage";
import { useHandbookArticle } from "./useHandbookArticle";

function HandbookArticle() {
  return <HandbookArticlePage {...useHandbookArticle()} />;
}

export default HandbookArticle;
